/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var InsurancePolicyType;

(function (InsurancePolicyType) {
  InsurancePolicyType["UNSPECIFIED"] = "unspecified";
  InsurancePolicyType["SCHEDULE"] = "schedule";
  InsurancePolicyType["CERTIFICATE"] = "certificate";
})(InsurancePolicyType || (InsurancePolicyType = {}));